import { HttpException } from 'exception/HttpException';

export class UserUnauthorizedException extends HttpException {
  constructor(message: string = 'User is not authorized.', httpCode?: number) {
    super(message, httpCode);
    Object.setPrototypeOf(this, UserUnauthorizedException.prototype);
  }
}
